// Multibrot (degree n) — four-slot fill-in (see README.md):
//   initial_state(p) = 0      parameter c = p      step = z^n + c      escaped = |z| > 2
//
// Degenerates to the Mandelbrot set exactly when degree == 2.

@group(0) @binding(0) var<storage, read_write> output: array<u32>;

struct Params {
  width:      u32,
  height:     u32,
  center_re:  f32,
  center_im:  f32,
  scale:      f32,
  max_iter:   u32,
  degree:     u32,
}
@group(0) @binding(1) var<uniform> params: Params;

const ESCAPE_R2: f32 = 4.0;

@compute @workgroup_size(8, 8)
fn main(@builtin(global_invocation_id) gid: vec3u) {
  if (gid.x >= params.width || gid.y >= params.height) { return; }

  let c = pixelToComplex(gid.x, gid.y, params.width, params.height, params.center_re, params.center_im, params.scale);
  var z = Complex(0.0, 0.0);

  var iter: u32 = 0u;
  loop {
    if (iter >= params.max_iter) { break; }
    z = cAdd(cPowN(z, params.degree), c);
    if (cAbs2(z) > ESCAPE_R2) { break; }
    iter = iter + 1u;
  }

  output[gid.y * params.width + gid.x] = colorize(iter, params.max_iter, z);
}
